import { useEffect, useState } from 'react';
import { cn, useMedias } from '@divlab/divanui';

import * as Profile from '@Queries/Profile';
import useTranslation from '@Queries/useTranslation';
import Form from './elems/Form/Form';
import Footnote from './elems/Footnote';
import styles from './Banner.module.css';

import type { FC, HTMLAttributes } from 'react';

interface BannerProps extends HTMLAttributes<HTMLDivElement> {
  banner: BannerData;
}

export type BannerData = {
  title: string;
  image: string;
};

const Banner: FC<BannerProps> = (props) => {
  const { className, banner, ...restProps } = props;
  const { data: profile, isLoading } = Profile.useProfile();
  const [isAuthorized, setIsAuthorized] = useState<boolean>(null);
  const [codeSent, setCodeSent] = useState(false);
  const { isMobile } = useMedias();
  const { t } = useTranslation();
  const [isClarificationStep, setisClarificationStep] = useState(false);
  const needToDisplayForm = (isAuthorized === false || isClarificationStep) && !isLoading;
  const needImage = !(codeSent && isMobile) && needToDisplayForm;

  const handleCodeSent = () => setCodeSent(true);
  const handleAuthorization = () => {
    setIsAuthorized(true);
    setisClarificationStep(false);
  };
  const trackClarificationStep = () => {
    setisClarificationStep(true);
  };

  useEffect(() => {
    setIsAuthorized(!!profile);
  }, [profile]);

  return (
    <div className={cn(className, { [styles.authorizedView]: !needToDisplayForm })} {...restProps}>
      <div className={styles.banner}>
        <div
          className={styles.container}
          style={
            needImage
              ? {
                  backgroundImage: `url(${banner.image})`,
                }
              : null
          }
        >
          <div className={styles.content}>
            <div className={styles.title}>{banner.title}</div>
            {!needToDisplayForm && <div className={styles.subtitle}>{t('get-cashback')}</div>}
            {needToDisplayForm && (
              <>
                <Form
                  className={styles.form}
                  onCodeSent={handleCodeSent}
                  onAuthorization={handleAuthorization}
                  onClarification={trackClarificationStep}
                />
                <Footnote className={styles.condition} />
              </>
            )}
          </div>
        </div>
      </div>

      {needToDisplayForm && <Footnote className={styles.condition} />}
    </div>
  );
};

export default Banner;
